import type { PropsCoreState } from '~/store/interfaces';

export const selectLogin = ({ login }: PropsCoreState) => login;
export const selectIsLoggedIn = ({ login }: PropsCoreState) => login.signed;
